import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible'

/**
 * Long text behind a disclosure, closed by default: the legal clause of a
 * resolution is read on demand, never in the way of the answer. Pattern
 * "collapsible long text" (docs/frontend/patterns.md).
 */
export function CollapsibleText({
    text,
    testId,
    label,
    defaultOpen = false,
}: {
    text: string
    testId: string
    /** Overrides the "Show text" / "Hide text" labels. */
    label?: { show: string; hide: string }
    defaultOpen?: boolean
}) {
    const { t } = useTranslation('assemblies')
    const [open, setOpen] = useState(defaultOpen)
    if (!text.trim()) return null
    return (
        <Collapsible open={open} onOpenChange={setOpen} data-testid={testId}>
            <CollapsibleTrigger
                className="text-xs font-medium text-primary underline-offset-2 hover:underline"
                data-testid={`${testId}-toggle`}
            >
                {open ? (label?.hide ?? t('text.hide')) : (label?.show ?? t('text.show'))}
            </CollapsibleTrigger>
            <CollapsibleContent>
                <p className="mt-2 whitespace-pre-wrap rounded-md bg-muted/40 p-3 text-sm" data-testid={`${testId}-body`}>
                    {text}
                </p>
            </CollapsibleContent>
        </Collapsible>
    )
}
